import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { createDataTestId } from '../../../utils/test/testIds';
import { AnimatedRingFill, LoaderIconRoot, Ring } from './LoaderIcon.styles';
export function LoaderIcon(_ref) {
  let {
    className,
    size,
    testId
  } = _ref;
  return React.createElement(LoaderIconRoot, _extends({
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "25 25 50 50",
    size: size
  }, createDataTestId(testId), {
    "data-component": "LoaderIcon"
  }), React.createElement(Ring, null), React.createElement(AnimatedRingFill, null));
}